import React from 'react';

import { BenefitType } from '@epi-constants/benefitTypes';
import { useIsMyChoiceValid } from '@epi-shared/hooks/useIsMyChoiceValid';
import {
  ContractedBenefitsSettings,
  IBenefits
} from '@epi-models/pages/BenefitGroups';

import { MyChoiceBenefit } from '../MyChoiceBenefit/MyChoiceBenefit';

type MyChoiceBenefitsListProps = {
  contractedBenefits: ContractedBenefitsSettings[];
  companyMyChoiceEnabled: boolean;
};

export const MyChoiceBenefitsList = ({
  contractedBenefits,
  companyMyChoiceEnabled
}: MyChoiceBenefitsListProps) => {
  const isMyChoiceValid = useIsMyChoiceValid(contractedBenefits);

  return (
    <>
      {contractedBenefits.map(
        ({
          benefitType,
          maxAmount,
          minAmount,
          taxFreeAmount,
          myChoiceEnabled
        }) =>
          benefitType !== BenefitType.Lunch ? (
            <MyChoiceBenefit
              benefitName={benefitType as IBenefits}
              maxAmounts={[maxAmount, minAmount]}
              key={`myChoiceBenefit-${benefitType}`}
              taxFreeAmount={taxFreeAmount}
              myChoiceEnabled={myChoiceEnabled && companyMyChoiceEnabled}
              isMyChoiceValid={isMyChoiceValid}
            />
          ) : null
      )}
    </>
  );
};
